/* eslint-disable indent */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Select from "react-select";

import SelectInput2 from "../../../component/input/SelectInput2";
import TextInput2 from "../../../component/input/TextInput2";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../../constant/helper/helper";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import Button from "../../../component/button/Button";
import RenderToolTip from "../../../component/tooltip/RenderToolTip";
import { toolTipData, selectOptions } from "./canteenStaticData";

const TopInput = ({
  values,
  loading,
  onSubmit,
  onChange,
  allLocations,
  currentUser,
  selectedCategory,
  handleSelectCategories
}) => {
  return (
    <Fragment>
      <div className="row">
        <RenderToolTip toolTipData={toolTipData} />
        <div className="col-lg-3 col-md-3 col-sm-12">
          <TextInput2
            data-tip
            type="date"
            name="date"
            data-for="date"
            onChange={onChange}
            value={values.date}
            placeholder="Select Date"
            icon="mdi mdi-calendar-check"
          />
        </div>

        <div className="col-lg-3 col-md-3 col-sm-12">
          <SelectInput2
            data-tip
            name="locationId"
            isLabeled={true}
            onChange={onChange}
            data-for="locationName"
            label="Select Location"
            value={values.locationId}
            placeholder="Select Location"
            icon="mdi mdi-map-marker-radius"
          >
            {isSuperAdmin(currentUser)
              ? renderLocationFunction(allLocations)
              : renderAccessLocation2(
                  locationRender(currentUser, false)
                )}
          </SelectInput2>
        </div>
        <div className="col-lg-6 col-md-6">
          <Select
            isMulti
            name="categories"
            options={selectOptions}
            classNamePrefix="select"
            className="basic-multi-select"
            defaultValue={selectedCategory}
            onChange={handleSelectCategories}
            placeholder={"Select More Filters And Get Data"}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-lg-4 col-md-4">
          <TextInput2
            data-tip
            type="text"
            name="Filter"
            data-for="Filter"
            onChange={onChange}
            value={values.Filter}
            icon="mdi mdi-magnify"
            placeholder="Search..."
          />
        </div>

        {loading === true ? (
          <div className="col-sm-2 col-md-2 col-lg-2">
            <SpinnerButton />
          </div>
        ) : (
          <div className="col-sm-2 col-md-2 col-lg-2">
            <div className="form-group">
              <Button
                title="GET"
                type="button"
                onClick={onSubmit}
                isBackgroundColor={false}
                icon="mdi mdi-plus-circle-outline mr-2"
                className="btn mb-2 text-white btn-dark btn-block"
              />
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

TopInput.propTypes = {
  loading: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  allLocations: PropTypes.array.isRequired,
  selectedCategory: PropTypes.array.isRequired,
  handleSelectCategories: PropTypes.func.isRequired
};

export default TopInput;
